import { useState } from 'react';
import Button from '@components/common/button';
import styles from './styles.module.scss';
import TransactionTable from '@components/transactions_table';
import { useNavigate } from 'react-router-dom';
import { routes } from '@const/routes';
import { useApiQuery } from '@hooks/api/useApiQuery';
import { apiTransactionsService } from '@api';
import { ENewNotificationType } from '@enum';
import { useLocales } from '@hooks/helpers/useLocales';
import Typography from '@components/common/typography';
import Tabs from '@components/tabs';
import { ETransactionType } from '@xeppt/xeppt-sdk/types';

const TransactionsSection = () => {
    // const { t } = useTranslation('sections', {
    //     keyPrefix: 'dashboard.transactions'
    // });
    const [activeTab, setActiveTab] = useState('transactions');
    const navigate = useNavigate();
    const { submitLocale } = useLocales();

    const {
        data: transactions,
        isLoading: isTransactionsLoading,
        handleRequest: refetchTransactions
    } = useApiQuery({
        method: () => apiTransactionsService.findTransactions({}, { cursor: new Date(), limit: 6 }),
        notificationType: ENewNotificationType.TRANSACTION,
        condition: activeTab === 'transactions',
        deps: [activeTab]
    });

    const {
        data: intents,
        isLoading: isIntentsLoading,
        handleRequest: refetchIntents
    } = useApiQuery({
        method: () =>
            apiTransactionsService.getPaymentIntents({
                limit: 6,
                cursor: new Date(),
                type: [ETransactionType.DEBIT]
            }),
        notificationType: ENewNotificationType.TRANSACTION,
        condition: activeTab === 'requests',
        deps: [activeTab]
    });

    return (
        <div className={styles.wrapper}>
            <div className={styles.content}>
                <div className={styles.table_header}>
                    {/*<Typography variant="h4" className={styles.title}>
                        Transactions
                    </Typography>*/}
                    <Tabs
                        onChange={(val) => setActiveTab(val)}
                        tabs={[
                            {
                                label: 'Transactions',
                                value: 'transactions'
                            },
                            {
                                label: 'External requests',
                                value: 'requests'
                            }
                        ]}
                        activeTab={activeTab}
                    />
                    <Button
                        className={styles.all}
                        rightIcon="arrow_right"
                        variant="text-gray"
                        onClick={() => navigate(routes.transactions)}>
                        {submitLocale('view_all')}
                    </Button>
                </div>
                <TransactionTable
                    activeTab={activeTab}
                    refetchTransactions={
                        activeTab === 'transactions' ? refetchTransactions : refetchIntents
                    }
                    isTransactionsLoading={
                        activeTab === 'transactions' ? isTransactionsLoading : isIntentsLoading
                    }
                    transactions={
                        activeTab === 'transactions' ? transactions?.data : intents?.data || []
                    }
                />
            </div>
        </div>
    );
};

export default TransactionsSection;
